import { render, staticRenderFns } from "./EmbryoTransferPage.vue?vue&type=template&id=6c09ef22&scoped=true&"
import script from "./EmbryoTransferPage.vue?vue&type=script&lang=js&"
export * from "./EmbryoTransferPage.vue?vue&type=script&lang=js&"
import style0 from "./EmbryoTransferPage.vue?vue&type=style&index=0&id=6c09ef22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c09ef22",
  null
  
)

export default component.exports